import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CollapsedSidepanelComponent } from './collapsed-sidepanel.component';
import { RoblexDirectivesModule } from '../../directives/roblex-directives.module';
import { CollapsedSidepanelOverlayComponent } from './collapsed-sidepanel-overlay/collapsed-sidepanel-overlay.component';
import { RoblexCollapsedSidepanelConfig } from '../../config/collapsed-sidepanel/collapsed-sidepanel.config';
import { CollapsedSidepanelInsertionDirective } from './collapsed-sidepanel.directive';
import { CollapsedSidepanelContentComponent } from './collapsed-sidepanel-content/collapsed-sidepanel-content.component';

@NgModule({
    declarations: [
        CollapsedSidepanelComponent,
        CollapsedSidepanelOverlayComponent,
        CollapsedSidepanelInsertionDirective,
        CollapsedSidepanelContentComponent,
    ],
    imports: [CommonModule, RoblexDirectivesModule],
    entryComponents: [CollapsedSidepanelComponent],
    exports: [CollapsedSidepanelComponent],
    providers: [RoblexCollapsedSidepanelConfig],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RoblexCollapsedSidepanelModule {}
